import { render, staticRenderFns } from "./Legends.vue?vue&type=template&id=2db815fa&scoped=true&"
import script from "./Legends.vue?vue&type=script&lang=js&"
export * from "./Legends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db815fa",
  null
  
)

export default component.exports